import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=3ea9dcea"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=3ea9dcea&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports